export default "__VITE_ASSET__DlbpzXi1__"